import React from 'react';
import logComponent from '../../common/logComponent';
import './Logo.css';

export default function logo() {
  if (logComponent('logo')) { console.debug('logo rendered'); }

  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  viewBox="0 0 240 240" style={{enableBackground: 'new 0 0 240 240'}}>
      <g id="Layer_1">
      </g>
      <g id="Guides">
      <g>
        <g>
          <g>
            <g>
              <path className="st0" d="M14.7,120C14.7,61.9,61.9,14.7,120,14.7c58.1,0,105.3,47.1,105.3,105.3c0,58.1-47.1,105.3-105.3,105.3
                C61.9,225.3,14.7,178.1,14.7,120z"/>
              <path className="st1" d="M120,231.1C58.7,231.1,8.9,181.3,8.9,120C8.9,58.7,58.7,8.9,120,8.9c61.3,0,111.1,49.8,111.1,111.1
                C231.1,181.3,181.3,231.1,120,231.1z M120,20.6c-54.8,0-99.4,44.6-99.4,99.4c0,54.8,44.6,99.4,99.4,99.4
                c54.8,0,99.4-44.6,99.4-99.4C219.4,65.2,174.8,20.6,120,20.6z"/>
            </g>
            <g>
              <path className="st2" d="M120,120"/>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path className="st3" d="M87,84.5c-6.7,0-12.2,5.4-12.2,12.2v32.7c0,6.7,5.4,12.2,12.2,12.2h28.1L96.5,84.5H87z"/>
          </g>
          <g>
            <path className="st3" d="M149.4,84.5h-9.5l-18.6,57.1h28.1c6.7,0,12.2-5.4,12.2-12.2V96.6C161.6,89.9,156.2,84.5,149.4,84.5z"/>
          </g>
          <g>
            <path className="st3" d="M140.7,61.4c0-12.4-10-22.5-22.5-22.5C105.8,39,95.8,49,95.8,61.4c0,12.4,10.1,22.4,22.5,22.4
              C130.6,83.9,140.7,73.8,140.7,61.4z"/>
          </g>
        </g>
        <g>
          <g>
            <path className="st0" d="M120.3,139.8h-4.1c-2.3,0-4.2-1.9-4.2-4.2V133c0-2.3,1.9-4.2,4.2-4.2h4.1c2.3,0,4.2,1.9,4.2,4.2v2.6
              C124.5,137.9,122.6,139.8,120.3,139.8z"/>
            <path className="st4" d="M120.3,141.3h-4.1c-3.1,0-5.7-2.6-5.7-5.7V133c0-3.1,2.6-5.7,5.7-5.7h4.1c3.1,0,5.7,2.6,5.7,5.7v2.6
              C126,138.7,123.4,141.3,120.3,141.3z M116.2,130.3c-1.5,0-2.7,1.2-2.7,2.7v2.6c0,1.5,1.2,2.7,2.7,2.7h4.1c1.5,0,2.7-1.2,2.7-2.7
              V133c0-1.5-1.2-2.7-2.7-2.7H116.2z"/>
          </g>
          <g>
            <g>
              <path className="st1" d="M140.8,199.4H95.6c-1.3,0-2.4-1.1-2.4-2.4v-57.7c0-1.3,1.1-2.4,2.4-2.4h45.2c1.3,0,2.4,1.1,2.4,2.4v57.7
                C143.2,198.4,142.1,199.4,140.8,199.4z"/>
            </g>
            <g>
              <rect x="97.9" y="141.3" className="st0" width="40.7" height="53.8"/>
            </g>
          </g>
          <g>
            <g>
              <path className="st1" d="M127.3,145.3h-18.2c-1.3,0-2.4-1.1-2.4-2.4v-8.4c0-1.3,1.1-2.4,2.4-2.4h18.2c1.3,0,2.4,1.1,2.4,2.4v8.4
                C129.7,144.3,128.6,145.3,127.3,145.3z"/>
            </g>
            <g>
              <rect x="110.2" y="135.8" className="st0" width="16" height="6"/>
            </g>
          </g>
        </g>
        <g>
          <path className="st1" d="M134.5,154.8H102c-0.9,0-1.6-0.7-1.6-1.6v-1c0-0.9,0.7-1.6,1.6-1.6h32.5c0.9,0,1.6,0.7,1.6,1.6v1
            C136.1,154.1,135.4,154.8,134.5,154.8z"/>
        </g>
        <g>
          <path className="st1" d="M121.1,166.5H102c-0.9,0-1.6-0.7-1.6-1.6v-1c0-0.9,0.7-1.6,1.6-1.6h19.2c0.9,0,1.6,0.7,1.6,1.6v1
            C122.7,165.8,122,166.5,121.1,166.5z"/>
        </g>
        <g>
          <path className="st1" d="M116.6,178.2H102c-0.9,0-1.6-0.7-1.6-1.6v-1c0-0.9,0.7-1.6,1.6-1.6h14.6c0.9,0,1.6,0.7,1.6,1.6v1
            C118.2,177.4,117.5,178.2,116.6,178.2z"/>
        </g>
        <g>
          <path className="st1" d="M119.4,189.8H102c-0.9,0-1.6-0.7-1.6-1.6v-1c0-0.9,0.7-1.6,1.6-1.6h17.5c0.9,0,1.6,0.7,1.6,1.6v1
            C121,189.1,120.3,189.8,119.4,189.8z"/>
        </g>
        <g>
          <circle className="st0" cx="136.5" cy="177.3" r="13.5"/>
        </g>
        <g>
          <path className="st3" d="M126.4,187.4c2.7,2.7,6.3,4.2,10.1,4.2c2.6,0,5.1-0.7,7.3-2c2.7,3.2,5.3,6.4,7.9,9.4
            c0.4,0.4,1.1,0.6,1.5,0.4c2.4-1.2,4.3-3.1,5.5-5.5c0.2-0.5,0-1.2-0.4-1.5c-3.1-2.5-6.2-5.2-9.4-7.9c3.2-5.5,2.5-12.7-2.2-17.4
            c-2.7-2.7-6.3-4.2-10.1-4.2c-3.8,0-7.4,1.5-10.1,4.2C120.8,172.7,120.8,181.8,126.4,187.4z M129.8,170.5c1.8-1.8,4.2-2.8,6.7-2.8
            c2.5,0,4.9,1,6.7,2.8c3.7,3.7,3.7,9.8,0,13.5c-1.8,1.8-4.2,2.8-6.7,2.8c-2.5,0-4.9-1-6.7-2.8
            C126.1,180.3,126.1,174.2,129.8,170.5z"/>
        </g>
      </g>
      </g>
    </svg>);

}